module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/hero@2x.10700a4.png";